import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BudgetProposalT, NatureT } from 'routes/BudgetModule/config/types';
import { RQAPICallWithData } from 'store/APIClient';

export const useGetAvailableNaturesForBudgetProposal = (
    budgetProposal: BudgetProposalT,
): UseQueryResult<NatureT[]> => {
    return useQuery({
        queryKey: [budgetProposal.id, 'budget/inscription/nature'],

        queryFn: async () => {
            const response = await RQAPICallWithData<NatureT[]>({
                endpoint: `budget/inscription/nature/${budgetProposal.id}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
};
